import axios from 'axios';
import { isMockApiMode } from '../config/apiMode';
import { createMockAdapter } from '../mocks/httpMock';

// A base da API vem da variavel de ambiente REACT_APP_API_URL, definida por
// ambiente na Vercel:
//   Production        -> https://api.soter.com.br
//   Preview (develop) -> http://apihg.soter.com.br (ou apihg em https quando disponivel)
// Fallback para producao caso a variavel nao esteja definida, para nunca
// apontar producao para um ambiente errado por engano.
const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://api.soter.com.br/';

const axiosInstance = axios.create({
  withCredentials: false,
  baseURL: API_BASE_URL,
  adapter: isMockApiMode ? createMockAdapter() : undefined,
});

export default axiosInstance;
